function toRad(deg) {
  return (deg * Math.PI) / 180;
}

function normalizeCoord(input) {
  if (Array.isArray(input)) {
    let [a, b] = input;
    const looksLonLat = Math.abs(a) > Math.abs(b) && Math.abs(a) <= 180 && Math.abs(b) <= 90;
    const lat = looksLonLat ? b : a;
    const lon = looksLonLat ? a : b;
    return { lat, lon };
  }
  if (input && typeof input === 'object' && 'lat' in input && 'lon' in input)
    return { lat: Number(input.lat), lon: Number(input.lon) };
  throw new Error('Coordinate must be [lat, lon] or {lat, lon}.');
}

function validateCoord({ lat, lon }) {
  if (!(lat >= -90 && lat <= 90 && lon >= -180 && lon <= 180))
    throw new Error(`Invalid coordinate: lat=${lat}, lon=${lon}`);
}

function haversineMiles(coordA, coordB) {
  const A = normalizeCoord(coordA),
    B = normalizeCoord(coordB);
  validateCoord(A);
  validateCoord(B);
  const R = 3958.7613;
  const dLat = toRad(B.lat - A.lat);
  const dLon = toRad(B.lon - A.lon);
  const lat1 = toRad(A.lat),
    lat2 = toRad(B.lat);
  const a = Math.sin(dLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) ** 2;
  return R * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
}

// --- ETA helper ---
function formatMinutes(mins) {
  const m = Math.round(mins);
  const h = Math.floor(m / 60);
  const mm = m % 60;
  return h ? `${h}h ${mm}m` : `${mm}m`;
}

// *IMPORTANT NOTE*
// coordA should be in this format eg : eg: [42.0235002, -87.7339901]
// coordB should be in this format eg : eg: [42.0235002, -87.7339901]

export function distanceAndETA(
  coordA,
  coordB,
  { roadFactor = 1.35, avgSpeedMph = 22, trafficMultiplier = 1.0, fixedDelayMin = 2 } = {}
) {
  const crow = haversineMiles(coordA, coordB);
  const roadMiles = crow * roadFactor;
  const driveMinutes =
    (roadMiles / Math.max(1, avgSpeedMph)) * 60 * trafficMultiplier + fixedDelayMin;

  return {
    straightLineMiles: crow.toFixed(2),
    roadMiles: roadMiles.toFixed(2),
    etaMinutes: driveMinutes.toFixed(2),
    etaText: formatMinutes(driveMinutes),
  };
}

// roadFactor   = is depend on road condition if its 1.35 time will increase and if its 1.1 it will reduce
